module.exports = __webpack_public_path__ + "assets/d943a1d397cd80492831454471b3ae6b.png";